<template>
    <div>
        <div class="userInfo">
            <div class="left">
                <div class="header">
                    <div class="user">
                        <img class="avatar" v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" alt="头像"/>
                        <img class="avatar" v-else src="@/assets/default_avatar.png" alt="头像"/>
                        
                        <div>
                            <div class="name">{{ userInfo.nickName }}（技巧师）</div>
                            <div class="content">
                                <div>
                                    <div>双色球：{{ userInfo.doubleColorBall || 0 }}</div>
                                    <div>大乐透：{{ userInfo.lottery || 0 }}</div>
                                    <div class="lastDiv">缩水列表</div>
                                </div>
                                <div>
                                    <div>福彩3D：{{ userInfo.fucai3d || 0 }}</div>
                                    <div>体彩排三：{{ userInfo.pailieSan || 0 }}</div>
                                    <div class="lastDiv">历史成绩</div>
                                </div>
                                <div>
                                    <div>缩币文章</div>
                                    <div>浏览人数</div>
                                    <div class="lastDiv">加入关注</div>
                                </div>
                                <div>
                                    <div>免费预测</div>
                                    <div>粉丝人数</div>
                                    <div class="lastDiv">放入桌面</div>
                                </div>
                                
<!--                                <div>缩币缩水单：{{ userInfo.payCount || 0 }}</div>-->
<!--                                <div>免费缩水单：{{ userInfo.freeCount || 0 }}</div>-->
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
            <div class="right">
                <div v-for="(item, index) in right.arr" :key="index" :class="right.active === index ? 'active' : ''"
                     @click="right.active = index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="table">
            <div class="tit">
                <div>
                    近期成绩
                    <span>双色球</span>
                    <span>福彩3D</span>
                    <span>大乐透</span>
                    <span>排列三</span>
                </div>
                <div>
                    <span>历史</span>
                    <span>近20期</span>
                </div>
            </div>
            <div class="grid">
                <div>
                    <span>期号</span>
                    <span>80-89.9万</span>
                    <span>50-59.9万</span>
                    <span>15-21.9万</span>
                    <span>4-4.9万</span>
                    <span>5005注以下</span>
                    <span>杀6蓝</span>
                    <span>围4蓝</span>
                </div>
                <div v-for="(item, index) in 10" :key="index">
                    <span>123123</span>
                    <span>√</span>
                    <span>√</span>
                    <span>√</span>
                    <span>√</span>
                    <span>√</span>
                    <span>√</span>
                    <span>√</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getInfo} from "@/api/hangjiaguanli";

export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},
            
            right: {
                arr: [
                    {name: "缩水单大厅"},
                    {name: "EXCEL专区"},
                    {name: "缩水软件专区"},
                    {name: "实体投注站帮扶中心"},
                ],
                active: 0
            }
        };
    },
    mounted() {
        this.getUserInfo();
        this.getTechnicianResults();
    },
    methods: {
        getUserInfo() {
            getInfo({
                userId: this.vuex_userInfo.userId,
            }).then(res => {
                this.userInfo = res.data;
            })
        },
        // 技巧师成绩
        getTechnicianResults() {
            this.$http.get('/stage-api/pre/detail/achievmentTechList', {
                "preType": 0,
                // "preIndexType": "string",
                // "backNumber": "string",
                "createUser": this.vuex_userInfo.userId
            }).then(res => {
                console.log(res.data);
            })
        }
    }
    
    
    
    /**
     
     // 技巧师最新预测
     /pre/detail/tech/list
     
     * */
};
</script>

<style lang="scss" scoped>
.userInfo {
    display: flex;
    
    .left {
        flex: 1;
        
        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            
            .user {
                display: flex;
                
                .avatar {
                    width: 100px;
                    height: 100px;
                    border-radius: 10px;
                    margin-right: 10px;
                    border: 1px solid #eee;
                }
                
                > div {
                    flex: 1;
                    
                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }
                    
                    .content {
                        display: flex;
                        justify-content: space-between;
                        
                        .lastDiv {
                            margin-top: 15px;
                            background-color: #93d2f3;
                            padding: 5px 10px;
                            cursor: pointer;
                        }
                    }
                }
            }
            
            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;
                
                > div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }
    }
    
    .right {
        text-align: center;
        margin-left: 10px;
        width: 200px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        
        > div {
            font-weight: bold;
            font-size: 13px;
            color: #bd312a;
            padding: 8px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;
            
            &.active {
                background-color: #93d2f3;
            }
        }
    }
}

.table {
    .tit {
        background-color: #93d2f3;
        color: #bd312a;
        display: flex;
        justify-content: space-between;
        
        span {
            display: inline-block;
            padding: 10px;
        }
    }
    
    .grid {
        > div {
            display: grid;
            text-align: center;
            grid-template-columns: repeat(8, 1fr);
            
            span {
                border: 1px solid rgba(0, 0, 0, 0.1);
                padding: 10px 0;
            }
        }
    }
}
</style>
